import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const credentials = ['🎓 Bioquímica Nutricional', '📜 Especialista Hormonal', '🏆 +8 años de experiencia'];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-1">
      <div className="max-w-[1400px] mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-6xl mx-auto" data-id="element-3">
          {/* Left: Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex justify-center lg:justify-end" data-id="element-4">
            <div className="relative w-full max-w-sm" data-id="element-5">
              <div className="rounded-2xl shadow-gold overflow-hidden border border-gold/20" data-id="element-6">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=768&h=1024" alt="Coach Profesional" className="w-full h-auto object-cover aspect-[3/4]" data-id="element-7" />
              </div>
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-8" data-id="element-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-black leading-tight" data-id="element-9">
              He acompañado a{' '}
              <span className="text-gradient-gold" data-id="element-10">miles de mujeres</span> a
              recuperar bienestar, energía y confianza
            </h2>

            <div className="space-y-6 text-foreground/90 font-body text-base md:text-lg font-medium leading-relaxed" data-id="element-11">
              <p data-id="element-12">
                A los 38, me miré al espejo y no reconocí el cuerpo que veía.
                Comía "sano", entrenaba con constancia… y aun así la inflamación
                abdominal seguía, la cintura no respondía y mi energía estaba
                cada vez más inestable.
              </p>
              <p data-id="element-13">
                Ahí decidí ir más profundo y usar mi formación en bioquímica y
                nutrición hormonal para entender qué estaba pasando. Lo que
                descubrí cambió mi enfoque:{' '}
                <span className="text-secondary font-bold" data-id="element-14">
                  muchas veces el problema no es "comer mal", sino la forma en
                  que tu cuerpo regula glucosa, estrés, sueño e inflamación en
                  esta etapa.
                </span>
              </p>
            </div>

            <div className="bg-card border-l-4 border-gold p-6 rounded-r-xl shadow-lg space-y-3" data-id="element-15">
              <p className="text-xl md:text-2xl font-display font-bold italic text-gold-light leading-snug" data-id="element-16">
                "Mi misión: que ninguna mujer se resigne a sentirse incómoda en
                su cuerpo después de los 35."
              </p>
              <p className="text-[15px] md:text-base font-body font-medium text-foreground/80 leading-relaxed" data-id="element-17">
                Hay estrategia, hay método y se puede hacer sin extremos.
              </p>
            </div>

            <div className="flex flex-wrap gap-3 pt-4" data-id="element-18">
              {credentials.map((cred, i) => <span key={i} className="bg-muted rounded-full px-4 py-2.5 text-[15px] font-body font-medium text-foreground/90 border border-border" data-id="element-19">
                  {cred}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}